import { IMAGES } from '../constants/images';

export const TOP_DESTINATIONS = [
  { id: 'mumbai', city: 'Mumbai', country: 'India', price: 389, image: IMAGES.mumbai },
  { id: 'london', city: 'London', country: 'UK', price: 456, image: IMAGES.london },
  { id: 'nyc', city: 'New York', country: 'USA', price: 234, image: IMAGES.newYork },
  { id: 'bangkok', city: 'Bangkok', country: 'Thailand', price: 412, image: IMAGES.bangkok },
];

export const FEATURES = [
  { title: 'Simple & Fast Booking', text: 'Travel anywhere, anytime—select from hundreds of airlines and hotels worldwide.' },
  { title: 'Assistance Available 24/7', text: 'Our support team is available around the clock by phone and email.' },
  { title: 'Unbeatable Offers', text: 'Discover top flight and hotel deals from anywhere to everywhere.' },
  { title: 'Easy Cancellations', text: 'Flexible online changes backed by global customer assistance.' },
];

export const EXCLUSIVE_DEALS = [
  { id: 'd1', from: 'Miami', to: 'Atlanta', type: 'Roundtrip', days: 5, dates: 'Jun 12 – Jun 17', price: 251.72, image: IMAGES.miamiBeach },
  { id: 'd2', from: 'Chicago', to: 'Denver', type: 'Roundtrip', days: 4, dates: 'Jul 3 – Jul 7', price: 198.45, image: IMAGES.chicago },
  { id: 'd3', from: 'Seattle', to: 'San Diego', type: 'One Way', days: 1, dates: 'Aug 15', price: 134.99, image: IMAGES.mountainLake },
  { id: 'd4', from: 'Boston', to: 'Orlando', type: 'Roundtrip', days: 6, dates: 'Sep 1 – Sep 7', price: 289.0, image: IMAGES.tropicalBeach },
];

export const NEARBY_DEALS = [
  { city: 'Paris', month: 'June 2026', price: 478, image: IMAGES.paris },
  { city: 'London', month: 'July 2026', price: 312, image: IMAGES.londonBridge },
  { city: 'Tokyo', month: 'August 2026', price: 445, image: IMAGES.tokyo },
  { city: 'Dubai', month: 'September 2026', price: 367, image: IMAGES.dubai },
];

export const REVIEWS = [
  { title: 'Smooth booking experience', text: 'Booked flights and hotel in one go. Prices were clear and support answered within minutes.' },
  { title: 'Great deals on packages', text: 'Saved over $300 on a family package to Orlando. Highly recommend Farenodex.' },
  { title: 'Easy to change dates', text: 'Had to reschedule due to work. The self-service change flow was straightforward.' },
  { title: 'Trustworthy and fast', text: 'Compared several sites—Farenodex had the best total price with no hidden add-ons.' },
];

export const POPULAR_DESTINATIONS = [
  { city: 'Amsterdam', country: 'Netherlands', image: 'https://images.pexels.com/photos/1796730/pexels-photo-1796730.jpeg?auto=compress&cs=tinysrgb&w=1400' },
  { city: 'Chicago', country: 'USA', image: IMAGES.chicago },
  { city: 'Paris', country: 'France', image: IMAGES.paris },
  { city: 'Toronto', country: 'Canada', image: IMAGES.toronto },
  { city: 'Los Angeles', country: 'USA', image: IMAGES.losAngeles },
];

export const JOURNEY_STEPS = [
  {
    title: 'Before You Book',
    text: 'Compare fares, read baggage rules, and set price alerts so you book at the right time.',
    image: IMAGES.travelPlanning,
    alt: 'Traveler planning a trip with map and camera',
  },
  {
    title: 'After You Book',
    text: 'Manage trips, add seats, and get real-time flight updates from your dashboard.',
    image: IMAGES.luggageCouple,
    alt: 'Happy couple with luggage at the airport',
  },
  {
    title: 'Need Help?',
    text: 'Chat, call, or email our team—we resolve most issues in under 15 minutes.',
    image: IMAGES.supportAgent,
    alt: 'Customer support representative ready to assist',
  },
];

export const SEARCH_BANNERS = {
  flights: IMAGES.airplane,
  hotels: IMAGES.hotelRoom,
  cars: IMAGES.rentalCar,
  packages: IMAGES.vacationPackage,
  cruises: IMAGES.cruiseShip,
};

export const AIRPORTS = [
  'New York (JFK)', 'Los Angeles (LAX)', 'Chicago (ORD)', 'Miami (MIA)', 'Atlanta (ATL)',
  'London (LHR)', 'Paris (CDG)', 'Dubai (DXB)', 'Tokyo (NRT)', 'Mumbai (BOM)',
  'Bangkok (BKK)', 'Sydney (SYD)', 'Toronto (YYZ)', 'Boston (BOS)', 'Denver (DEN)',
];

export const CITIES = [
  'Paris', 'London', 'Tokyo', 'Dubai', 'New York', 'Miami', 'Bangkok', 'Amsterdam',
  'Chicago', 'Los Angeles', 'Toronto', 'Barcelona', 'Rome', 'Singapore', 'Sydney',
];

export const CAR_LOCATIONS = [
  'Los Angeles Airport', 'Miami Airport', 'Chicago Downtown', 'New York JFK',
  'Denver Airport', 'San Francisco Airport', 'Las Vegas Strip', 'Orlando Airport',
];
